module.exports = __webpack_public_path__ + "static/media/exercise-not-recognized.46db0284.png";